$(document).ready(function () {
    const maxWords = 40;
    const contentEl = $(".enable-info-tag-enable_read_more-btn-script .product-information-tag__body");
    const content = contentEl.text().trim();
    const words = content.split(/\s+/);

    if (words.length > maxWords) {
        const visibleText = words.slice(0, maxWords).join(" ");
        const hiddenText = words.slice(maxWords).join(" ");
        const html = `
        ${visibleText} 
            <span class="more-text" style="display:none;">${hiddenText}</span>
            <a href="#" class="read-more">Read More</a>
        `;
        contentEl.html(html);

        contentEl.on("click", ".read-more", function (e) {
            e.preventDefault();
            const link = $(this);
            const moreText = contentEl.find(".more-text");
            if (moreText.is(":visible")) {
                moreText.hide();
                link.text("Read More");
                contentEl.contents().filter(function() { return this.nodeType === 3; }).first().replaceWith(visibleText + " ");
            } else {
                moreText.show();
                link.text("Read Less");
            }
        });
    }

    // on click hide poster image
    $(".CCBS .right-block .poster-image-wrapper").on("click", function() {
        $(this).hide();
        const video = $(this).siblings(".collection-banner-custom-video");
        video.attr('controls', true)[0].play();
    });


    // Size chart page accordion toggle
    $(".SCAS .accordion-wapper .accordion-header").on("click", function() {
        $(this).parent(".accordion-wapper").toggleClass('active');
        $(this).siblings(".accordion-content").toggleClass('active');
        $(this).find(".accordion-icon").toggle();
    });
    $(".SCAS .accordion-wapper .accordion-header").first().click();
    $(".SCAS .accordion-wapper .accordion-tabs .accordion-tab-titles .accordion-tab-title").click(function() {
        const tabId = $(this).attr("block-id");
        $(this).parents(".accordion-tabs").find(".accordion-tab-titles .accordion-tab-title").removeClass("active");
        $(this).addClass("active");

        $(this).parents(".accordion-tabs").find(".tab-images-slider").hide();
        $(this).parents(".accordion-tabs").find(`.tab-images-slider[block-id='${tabId}']`).css("display", "flex");
    });
    $(".SCAS .accordion-wapper .accordion-tabs").each(function(){
        $(this).find(".accordion-tab-titles .accordion-tab-title").first().click();
    });


    // when scroll from top is 100px set logo width to 100px
    $(window).scroll(function() {
        if ($(this).scrollTop() > 100) {
            $('.shopify-section-header .header__logo--desktop .logo-img').css('width', '100px');
        } else {
            $('.shopify-section-header .header__logo--desktop .logo-img').css('width', 'var(--gsc-logo-width)');
        }
    });
});